/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetGlycerinAvailabilityFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetGlycerinAvailabilityFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { GlycerinAvailability } from '@packages/tracking';
import type { getGlycerinAvailability } from '.';

export const getGlycerinAvailabilityDataMock: GetGlycerinAvailabilityFragmentFragment = {
  state: 'AVAILABLE',
  message: 'within next 2 days',
};

export const getGlycerinAvailabilityReturnMock: ReturnType<typeof getGlycerinAvailability> = {
  availability: GlycerinAvailability.IMMEDIATELY,
  estimatedDelivery: getGlycerinAvailabilityDataMock.message,
};

export function getGetGlycerinAvailabilityFragmentedData(
  data?: GetGlycerinAvailabilityFragmentFragment,
) {
  return makeFragmentData(
    data || getGlycerinAvailabilityDataMock,
    GetGlycerinAvailabilityFragmentFragmentDoc,
  );
}
